/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-04-29T08:55:39.029
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHouseCycle,
	listHouseCycleInit,
	listHouseCycleByAuthorizations,
	deleteHouseCycle
	
} from '@api/house/HouseCycle';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHouseCycle({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseCycle(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseCycleByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseCycleByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseCycleInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseCycleInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseCycle({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseCycle({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
